import {
  RetrieveFighterFrequencyBySeason,
  RetrieveFighterFrequencyBySeasonFailure,
  RetrieveFighterFrequencyBySeasonPayload,
  RetrieveFighterFrequencyBySeasonSuccess,
  RetrieveFighterFrequencyBySeasonSuccessPayload,
  RetrieveUserSeason,
  RetrieveUserSeasonFailure,
  RetrieveUserSeasonPayload,
  RetrieveUserSeasonSuccess,
  RetrieveUserSeasonSuccessPayload,
  RetrieveUsersTotalPointsBySeason,
  RetrieveUsersTotalPointsBySeasonFailure,
  RetrieveUsersTotalPointsBySeasonPayload,
  RetrieveUsersTotalPointsBySeasonSuccess,
  RetrieveUsersTotalPointsBySeasonSuccessPayload,
  RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON,
  RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_FAILURE,
  RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_SUCCESS,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_FAILURE,
  RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_SUCCESS,
  RETRIEVE_USER_SEASON,
  RETRIEVE_USER_SEASON_FAILURE,
  RETRIEVE_USER_SEASON_SUCCESS,
  UpsertUserSeason,
  UpsertUserSeasonFailure,
  UpsertUserSeasonPayload,
  UpsertUserSeasonSuccess,
  UpsertUserSeasonSuccessPayload,
  UPSERT_USER_SEASON,
  UPSERT_USER_SEASON_FAILURE,
  UPSERT_USER_SEASON_SUCCESS,
} from './userSeason.action.type';

export const retrieveUserSeason = (
  payload: RetrieveUserSeasonPayload,
): RetrieveUserSeason => ({
  type: RETRIEVE_USER_SEASON,
  payload,
});

export const retrieveUserSeasonSuccess = (
  payload: RetrieveUserSeasonSuccessPayload,
): RetrieveUserSeasonSuccess => ({
  type: RETRIEVE_USER_SEASON_SUCCESS,
  payload,
});

export const retrieveUserSeasonFailure = (
  error: string,
): RetrieveUserSeasonFailure => ({
  type: RETRIEVE_USER_SEASON_FAILURE,
  payload: error,
});

export const upsertUserSeason = (
  payload: UpsertUserSeasonPayload,
): UpsertUserSeason => ({
  type: UPSERT_USER_SEASON,
  payload,
});

export const upsertUserSeasonSuccess = (
  payload: UpsertUserSeasonSuccessPayload,
): UpsertUserSeasonSuccess => ({
  type: UPSERT_USER_SEASON_SUCCESS,
  payload,
});

export const upsertUserSeasonFailure = (
  error: string,
): UpsertUserSeasonFailure => ({
  type: UPSERT_USER_SEASON_FAILURE,
  payload: error,
});

export const retrieveFighterFrequencyBySeason = (
  payload: RetrieveFighterFrequencyBySeasonPayload,
): RetrieveFighterFrequencyBySeason => ({
  type: RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON,
  payload,
});

export const retrieveFighterFrequencyBySeasonSuccess = (
  payload: RetrieveFighterFrequencyBySeasonSuccessPayload,
): RetrieveFighterFrequencyBySeasonSuccess => ({
  type: RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_SUCCESS,
  payload,
});

export const retrieveFighterFrequencyBySeasonFailure = (
  error: string,
): RetrieveFighterFrequencyBySeasonFailure => ({
  type: RETRIEVE_FIGHTER_FREQUENCY_BY_SEASON_FAILURE,
  payload: error,
});

export const retrieveUsersTotalPointsBySeason = (
  payload: RetrieveUsersTotalPointsBySeasonPayload,
): RetrieveUsersTotalPointsBySeason => ({
  type: RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON,
  payload,
});

export const retrieveUsersTotalPointsBySeasonSuccess = (
  payload: RetrieveUsersTotalPointsBySeasonSuccessPayload,
): RetrieveUsersTotalPointsBySeasonSuccess => ({
  type: RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_SUCCESS,
  payload,
});

export const retrieveUsersTotalPointsBySeasonFailure = (
  error: string,
): RetrieveUsersTotalPointsBySeasonFailure => ({
  type: RETRIEVE_USERS_TOTAL_POINTS_BY_SEASON_FAILURE,
  payload: error,
});
